import { createSlice } from '@reduxjs/toolkit';
import { TournamentBracket } from 'modules/championship/domain/interfaces/tournament-bracket';
import bracketsAdapter from './brackets.adapter';
import { fetchStages, setStageBracketsTeams, upsertStage } from './stages.actions';

const bracketsSlice = createSlice({
  name: 'brackets',
  initialState: bracketsAdapter.getInitialState(),
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchStages.fulfilled, (state, action) => {
      const brackets = action.payload.reduce<TournamentBracket[]>((acc, stage) => [...acc, ...stage.brackets], []);

      bracketsAdapter.setAll(state, brackets);
    });

    builder.addMatcher(setStageBracketsTeams.fulfilled.match, (state, action) => {
      const brackets = action.payload;
      return bracketsAdapter.upsertMany(state, brackets);
    });

    builder.addMatcher(upsertStage.fulfilled.match, (state, action) => {
      const { id: stageId, brackets } = action.payload.stage;
      const existingBrackets = bracketsAdapter.getSelectors().selectAll(state);
      const stageBracketKeys = existingBrackets.filter((b) => b.stageId === stageId).map((b) => b.id);

      const removedStageBracketsState = bracketsAdapter.removeMany(state, stageBracketKeys);
      return bracketsAdapter.upsertMany(removedStageBracketsState, brackets);
    });
  },
});

export default bracketsSlice;
